import { apiClient } from './apiClient';

import type { ApiResponse } from '@/types/auth.types';
import type {
  CreateJobPostingPayload,
  JobPosting,
  JobPostingListData,
  JobPostingListParams,
  UpdateJobPostingPayload,
} from '@/types/jobPosting.types';
import type { SubmissionListData } from '@/types/submission.types';

export async function getJobPostings(params: JobPostingListParams = {}): Promise<JobPostingListData> {
  const searchParams = new URLSearchParams();

  if (params.q) searchParams.set('q', params.q);
  if (params.status) searchParams.set('status', params.status);
  if (params.role) searchParams.set('role', params.role);
  if (params.siteState) searchParams.set('siteState', params.siteState);
  if (params.from) searchParams.set('from', params.from);
  if (params.to) searchParams.set('to', params.to);
  if (params.sortBy) searchParams.set('sortBy', params.sortBy);
  if (params.sortOrder) searchParams.set('sortOrder', params.sortOrder);
  if (params.page) searchParams.set('page', String(params.page));
  if (params.limit) searchParams.set('limit', String(params.limit));

  const query = searchParams.toString();
  const url = `/job-postings${query ? `?${query}` : ''}`;

  const response = await apiClient.get<ApiResponse<JobPostingListData>>(url);
  return response.data;
}

export async function getJobPosting(id: string): Promise<JobPosting> {
  const response = await apiClient.get<ApiResponse<{ jobPosting: JobPosting }>>(`/job-postings/${id}`);
  return response.data.jobPosting;
}

export async function createJobPosting(payload: CreateJobPostingPayload): Promise<JobPosting> {
  const response = await apiClient.post<ApiResponse<{ jobPosting: JobPosting }>>('/job-postings', payload);
  return response.data.jobPosting;
}

export async function updateJobPosting(id: string, payload: UpdateJobPostingPayload): Promise<JobPosting> {
  const response = await apiClient.put<ApiResponse<{ jobPosting: JobPosting }>>(`/job-postings/${id}`, payload);
  return response.data.jobPosting;
}

export async function cloneJobPosting(id: string): Promise<JobPosting> {
  const response = await apiClient.post<ApiResponse<{ jobPosting: JobPosting }>>(`/job-postings/${id}/clone`, {});
  return response.data.jobPosting;
}

export async function closeJobPosting(id: string): Promise<JobPosting> {
  const response = await apiClient.put<ApiResponse<{ jobPosting: JobPosting }>>(`/job-postings/${id}/close`, {});
  return response.data.jobPosting;
}

export async function getJobPostingSubmissions(id: string, page?: number, limit?: number): Promise<SubmissionListData> {
  const searchParams = new URLSearchParams();

  if (page) searchParams.set('page', String(page));
  if (limit) searchParams.set('limit', String(limit));

  const query = searchParams.toString();
  const url = `/job-postings/${id}/submissions${query ? `?${query}` : ''}`;

  const response = await apiClient.get<ApiResponse<SubmissionListData>>(url);
  return response.data;
}
